<div class="dev-compare">
  <h1>live_v2 dev compare</h1>
  <p class="dev-note">
    DEV-ONLY diagnostics. Compares the legacy plate detail against the experimental
    live_v2 read path. Not linked anywhere; never used by production rendering.
  </p>

  <div *ngIf="!enabled" class="disabled">
    This page is disabled (environment.liveV2CompareEnabled is false).
  </div>

  <ng-container *ngIf="enabled">
    <div class="controls">
      <input
        type="text"
        [(ngModel)]="registration"
        (keyup.enter)="search()"
        placeholder="Enter a registration e.g. JKZ72"
        autocomplete="off"
      />
      <button (click)="search()">Compare</button>
      <span class="examples">
        Try:
        <a *ngFor="let p of examplePlates" (click)="registration = p; search()">{{ p }}</a>
      </span>
    </div>

    <div *ngIf="loading" class="loading">Loading…</div>
    <div *ngIf="error" class="error">{{ error }}</div>

    <div *ngIf="result" class="results">
      <div class="flag-state">
        UseLiveV2 (API) =
        <strong>{{ result.useLiveV2Enabled ? 'ON' : 'OFF' }}</strong>
      </div>

      <div class="columns">
        <!-- LEGACY -->
        <section class="col legacy">
          <h2>Legacy</h2>
          <div *ngIf="!result.legacy" class="empty">No legacy result.</div>
          <table *ngIf="result.legacy">
            <tr><th>owner</th><td>{{ ownerLabel(result.legacy.owner) }}</td></tr>
            <tr><th>formatted</th><td>{{ result.legacy.formattedRegistration }}</td></tr>
            <tr><th>registration</th><td>{{ result.legacy.registrationString }}</td></tr>
            <tr><th>style</th><td>{{ result.legacy.style }}</td></tr>
            <tr><th>issueYear</th><td>{{ result.legacy.issueYear }}</td></tr>
            <tr><th>issueRegion</th><td>{{ result.legacy.issueRegion }}</td></tr>
            <tr><th>platexPrice (£)</th><td>{{ result.legacy.platexPrice }}</td></tr>
            <tr><th>category</th><td>{{ result.legacy.plateCategory }}</td></tr>
          </table>
        </section>

        <!-- LIVE_V2 -->
        <section class="col live-v2">
          <h2>live_v2</h2>
          <div *ngIf="!result.liveV2 || !result.liveV2.found" class="empty">
            Not found in live_v2.
          </div>
          <ng-container *ngIf="result.liveV2 && result.liveV2.found">
            <table>
              <tr><th>owner</th><td>{{ ownerLabel(result.liveV2.detail.owner) }}</td></tr>
              <tr><th>formatted</th><td>{{ result.liveV2.detail.formattedRegistration }}</td></tr>
              <tr><th>registration</th><td>{{ result.liveV2.detail.registrationString }}</td></tr>
              <tr><th>style</th><td>{{ result.liveV2.detail.style }}</td></tr>
              <tr><th>available</th><td>{{ result.liveV2.isAvailable }}</td></tr>
              <tr><th>bestPrice (pence)</th><td>{{ result.liveV2.bestPriceMinor }}</td></tr>
              <tr><th>dvlaPrice (pence)</th><td>{{ result.liveV2.dvlaPriceMinor }}</td></tr>
              <tr><th>listings</th><td>{{ result.liveV2.activeListingCount }}</td></tr>
              <tr><th>bestSource</th><td>{{ result.liveV2.bestSourceType }}</td></tr>
              <tr><th>platexPrice (£)</th><td>{{ result.liveV2.detail.platexPrice }}</td></tr>
            </table>

            <h3>Sellers ({{ result.liveV2.sellers.length }})</h3>
            <table class="sellers" *ngIf="result.liveV2.sellers.length">
              <tr>
                <th>site</th><th>type</th><th>price (p)</th><th>cheapest</th><th>last seen</th>
              </tr>
              <tr *ngFor="let s of result.liveV2.sellers">
                <td><a [href]="s.purchaseUrl" target="_blank" rel="noopener">{{ s.siteName }}</a></td>
                <td>{{ s.sourceType }}</td>
                <td>{{ s.totalPriceMinor }}</td>
                <td>{{ s.isCheapest ? '✓' : '' }}</td>
                <td>{{ s.lastSeenAt }}</td>
              </tr>
            </table>

            <h3>SEO contract</h3>
            <table *ngIf="result.liveV2.seo">
              <tr><th>canonicalSlug</th><td>{{ result.liveV2.seo.canonicalSlug }}</td></tr>
              <tr><th>canonicalUrl</th><td>{{ result.liveV2.seo.canonicalUrl }}</td></tr>
              <tr><th>indexable</th><td>{{ result.liveV2.seo.isIndexable }}</td></tr>
              <tr><th>noindexReason</th><td>{{ result.liveV2.seo.noindexReason }}</td></tr>
              <tr><th>metaTitle</th><td>{{ result.liveV2.seo.metaTitle }}</td></tr>
              <tr><th>metaDescription</th><td>{{ result.liveV2.seo.metaDescription }}</td></tr>
              <tr><th>h1</th><td>{{ result.liveV2.seo.h1 }}</td></tr>
            </table>
            <div *ngIf="!result.liveV2.seo" class="empty">No SEO row.</div>
          </ng-container>
        </section>
      </div>

      <!-- PARITY -->
      <section class="parity" *ngIf="result.parityNotes?.length">
        <h2>Parity notes</h2>
        <ul>
          <li *ngFor="let note of result.parityNotes">{{ note }}</li>
        </ul>
      </section>
    </div>
  </ng-container>
</div>
